import * as React from "react";
import { FunctionComponent, useState, useEffect } from "react";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input/input';
import { isValidPhoneNumber, formatPhoneNumber, isPossiblePhoneNumber } from "react-phone-number-input";
import { AutoClaimReport, ClaimType } from "../../../Models/Claim";
import FileDragAndDrop from "../../FileDragAndDrop";
import { FilesTable } from "../../FilesTable";
import ReactTooltip from 'react-tooltip';
import { ByteLimit, AfterToolTipHide, AfterToolTipShow, ValidateEmail } from "../../../Utils";
import { Collapse, ProgressBar } from "react-bootstrap";
import Server from "../../../Server";

interface StepFourProps {
	goBack: (step: number, claim: AutoClaimReport) => void;
    submit: (claim: AutoClaimReport) => void;
	claim: AutoClaimReport;
	showError: boolean;
    doGoBackCallback: boolean;
    goBackCallbackStep: number;
    doSubmit: boolean;
}

export const StepFour: FunctionComponent<StepFourProps> = ({ goBack, claim, showError, doGoBackCallback, goBackCallbackStep, doSubmit, submit}) => {
	const [shouldScroll, setShouldScroll] = useState<boolean>(true);
	const [width, setWidth] = useState<number>(window.innerWidth);
    const [openInjuryOne, setOpenInjuryOne] = useState<boolean>(localStorage.getItem("autoclaim-inj1Open") === "true");
    const [openInjuryTwo, setOpenInjuryTwo] = useState<boolean>(localStorage.getItem("autoclaim-inj2Open") === "true");
    const [openWitnessOne, setOpenWitnessOne] = useState<boolean>(localStorage.getItem("autoclaim-wit1Open") === "true");
    const [openWitnessTwo, setOpenWitnessTwo] = useState<boolean>(localStorage.getItem("autoclaim-wit2Open") === "true");
	const [areInjuries, setAreInjuries] = useState<string>(localStorage.getItem("autoclaim-areinjuries") || "");
	const [injuryOneNameAndAddress, setInjuryOneNameAndAddress] = useState<string>(claim.additionalAnswers["injuryOneName"] || "");
	const [injuryOnePhone, setInjuryOnePhone] = useState<string>(claim.additionalAnswers["injuryOnePhone"] || "");
	const [injuryOneLocation, setInjuryOneLocation] = useState<string>(claim.additionalAnswers["injuryOneLocation"] || "");
	const [injuryOneDescription, setInjuryOneDescription] = useState<string>(claim.additionalAnswers["injuryOneDescription"] || "");
	const [injuryTwoNameAndAddress, setInjuryTwoNameAndAddress] = useState<string>(claim.additionalAnswers["injuryTwoName"] || "");
	const [injuryTwoPhone, setInjuryTwoPhone] = useState<string>(claim.additionalAnswers["injuryTwoPhone"] || "");
	const [injuryTwoLocation, setInjuryTwoLocation] = useState<string>(claim.additionalAnswers["injuryTwoLocation"] || "");
	const [injuryTwoDescription, setInjuryTwoDescription] = useState<string>(claim.additionalAnswers["injuryTwoDescription"] || "");
	const [areWitness, setAreWitness] = useState<string>(localStorage.getItem("autoclaim-arewitness") || "");
	const [witnessOneNameAndAddress, setWitnessOneNameAndAddress] = useState<string>(claim.additionalAnswers["witnessOneName"] || "");
	const [witnessOnePhone, setWitnessOnePhone] = useState<string>(claim.additionalAnswers["witnessOnePhone"] || "");
	const [witnessOneLocation, setWitnessOneLocation] = useState<string>(claim.additionalAnswers["witnessOneLocation"] || "");
	const [witnessOneOrPassenger, setWitnessOneOrPassenger] = useState<string>(claim.additionalAnswers["witnessOnePassenger"] || "");
	const [witnessTwoNameAndAddress, setWitnessTwoNameAndAddress] = useState<string>(claim.additionalAnswers["witnessTwoName"] || "");
	const [witnessTwoPhone, setWitnessTwoPhone] = useState<string>(claim.additionalAnswers["witnessTwoPhone"] || "");
	const [witnessTwoLocation, setWitnessTwoLocation] = useState<string>(claim.additionalAnswers["witnessTwoLocation"] || "");
	const [witnessTwoOrPassenger, setWitnessTwoOrPassenger] = useState<string>(claim.additionalAnswers["witnessTwoPassenger"] || "");
	const [remarks, setRemarks] = useState<string>(claim.remarks);

	useEffect(() => {
		if (shouldScroll) {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
			setShouldScroll(false);
		}
	}, [shouldScroll])

    useEffect(() =>{
        if (showError)
        {
            console.log("step four error handler check");
            handleErrors();
        }
    },[showError]);

    useEffect(() =>{
        if (doGoBackCallback && goBackCallbackStep !== -1)
            goToStep(goBackCallbackStep);
    }, [doGoBackCallback])

    useEffect(() =>{
        if (doSubmit)
            submitClaim();
    }, [doSubmit])

    function handleErrors()
    {
        if(showError && injuryOnePhone !== "" && !isValidPhoneNumber(injuryOnePhone))
        {
            localStorage.setItem("autoclaim-inj1Open","true");
            setOpenInjuryOne(true);
        }
        if(showError && injuryTwoPhone !== "" && !isValidPhoneNumber(injuryTwoPhone))
        {
            localStorage.setItem("autoclaim-inj2Open","true");
            setOpenInjuryTwo(true);
        }
        if(showError && witnessOnePhone !== "" && !isValidPhoneNumber(witnessOnePhone))
        {
            localStorage.setItem("autoclaim-wit1Open","true");
            setOpenWitnessOne(true);
        }
        if(showError && witnessTwoPhone !== "" && !isValidPhoneNumber(witnessTwoPhone))
        {
            localStorage.setItem("autoclaim-wit2Open","true");
            setOpenWitnessTwo(true);
        }
    }

	function handleWindowSizeChange() {
		setWidth(window.innerWidth);
	}


	useEffect(() => {
		window.addEventListener('resize', handleWindowSizeChange);
		return () => {
			window.removeEventListener('resize', handleWindowSizeChange);
		}
	}, []);

	let isMobile: boolean = (width <= 768);

	return <div className="step-four">
		<div className="form-group injuries-dropdown">
			<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="any-injuries" >Were there any injuries?</label>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <select className="form-control" id="any-injuries" aria-describedby="relationTypeError" value={areInjuries} name="Any Injuries" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    setAreInjuries(e.target.value);
                    localStorage.setItem("autoclaim-areinjuries",e.target.value);
                }}>
                    <option value="">Select...</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>
            </div>
		</div>
        <Collapse in={areInjuries === "Yes"}>
            <div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <button className="btn btn-primary" type="button" onClick={() =>{localStorage.setItem("autoclaim-inj1Open",(!openInjuryOne).toString()); setOpenInjuryOne(!openInjuryOne)}}><i className="fa fa-pencil" aria-hidden="true" />&nbsp;First Injury</button>
                </div>
                <Collapse className="outline col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom" in={openInjuryOne}>
                    <div>
                        <div className="injured-one">
                            <div className="form-group">
                                <label className="control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" htmlFor="injured-one-name">Name and Address:</label>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <textarea className="form-control" id="injured-one-name" aria-describedby="injuryOneName" maxLength={75} placeholder="John Smith 123 Main Street, Town, State " name="First Injury Name and Address" value={injuryOneNameAndAddress} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                        setInjuryOneNameAndAddress(e.target.value);
                                    }} />
                                    <p id="injuryOneName"><strong>Maximum 75 characters.  You have used {injuryOneNameAndAddress.length} characters.</strong></p>
                                </div> 
                            </div>
                            <div className="form-group">
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <label className="control-label" htmlFor="injured-one-phone">Phone Number:</label>
                                    <PhoneInput id="injured-one-phone" placeholder="(123)-456-7890" name="Injury One Phone" aria-invalid={showError && (injuryOnePhone !== "" && !isValidPhoneNumber(injuryOnePhone))} aria-describedby="injuryOnePhoneError" country="US" international={false} className="form-control" value={injuryOnePhone} maxLength={14} onChange={(phone: string) => {
                                        if (!phone) phone = "";
                                        setInjuryOnePhone(phone);
                                    }} />
                                    <p id="injuryOnePhoneError" className={showError && (injuryOnePhone !== "" && !isValidPhoneNumber(injuryOnePhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <label className="control-label" htmlFor="injured-one-location">Location of Injured Party</label>
                                    <select className="form-control" id="injured-one-locations" aria-describedby="relationTypeError" value={injuryOneLocation} name="Injury One Location" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                        setInjuryOneLocation(e.target.value);
                                    }}>
                                        <option value="">Select...</option>
                                        <option value="Pedestrian">Pedestrian</option>
                                        <option value="Insured Vehicle">Insured Vehicle</option>
                                        <option value="Other Vehicle">Other Vehicle</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" htmlFor="injured-one-description">Describe Injury:</label>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <textarea className="form-control" id="injured-one-description" aria-describedby="injuryOneDescription" maxLength={45} placeholder="Minor Injuries" name="Second Injury Description" value={injuryOneDescription} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                        setInjuryOneDescription(e.target.value);
                                    }} />
                                    <p id="injuryOneDescription"><strong>Maximum 45 characters.  You have used {injuryOneDescription.length} characters.</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom">
                    <button className="btn btn-primary" type="button" onClick={() =>{localStorage.setItem("autoclaim-inj2Open",(!openInjuryTwo).toString());setOpenInjuryTwo(!openInjuryTwo)}}><i className="fa fa-pencil" aria-hidden="true" />&nbsp;Second Injury</button>
                </div>
                <Collapse className="outline col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom" in={openInjuryTwo}>
                    <div>
                        <div className="injured-two">
                            <div className="form-group">
                                <label className="control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" htmlFor="injured-two-name">Name and Address:</label>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <textarea className="form-control" id="injured-two-name" aria-describedby="injuryTwoName" maxLength={75} placeholder="John Smith 123 Main Street, Town, State " name="Second Injury Name and Address" value={injuryTwoNameAndAddress} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                        setInjuryTwoNameAndAddress(e.target.value);
                                    }} />
                                    <p id="injuryTwoName"><strong>Maximum 75 characters.  You have used {injuryTwoNameAndAddress.length} characters.</strong></p>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <label className="control-label" htmlFor="injured-two-phone">Phone Number:</label>
                                    <PhoneInput id="injured-two-phone" placeholder="(123)-456-7890" name="Injury Two Phone" aria-invalid={showError && (injuryTwoPhone !== "" && !isValidPhoneNumber(injuryTwoPhone))} aria-describedby="injuryTwoPhoneError" country="US" international={false} className="form-control" value={injuryTwoPhone} maxLength={14} onChange={(phone: string) => {
                                        if (!phone) phone = "";
                                        setInjuryTwoPhone(phone);
                                    }} />
                                    <p id="injuryTwoPhoneError" className={showError && (injuryTwoPhone !== "" && !isValidPhoneNumber(injuryTwoPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <label className="control-label" htmlFor="injured-two-location">Location of Injured Party</label>
                                    <select className="form-control" id="injured-two-locations" aria-describedby="relationTypeError" value={injuryTwoLocation} name="Injury Two Location" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                        setInjuryTwoLocation(e.target.value);
                                    }}>
                                        <option value="">Select...</option>
                                        <option value="Pedestrian">Pedestrian</option>
                                        <option value="Insured Vehicle">Insured Vehicle</option>
                                        <option value="Other Vehicle">Other Vehicle</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" htmlFor="injured-two-description">Describe Injury:</label>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <textarea className="form-control" id="injured-two-description" aria-describedby="injuryTwoDescription" maxLength={45} placeholder="Minor Injuries" name="Second Injury Description" value={injuryTwoDescription} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                        setInjuryTwoDescription(e.target.value);
                                    }} />
                                    <p id="injuryTwoDescription"><strong>Maximum 45 characters.  You have used {injuryTwoDescription.length} characters.</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
                <p><strong>*If there are any additional injuries, please explain in the remarks section below</strong></p>
            </div>
        </Collapse>
		<div className="form-group witness-dropdown">
			<label className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12" htmlFor="any-witnesses">Were there any witnesses or passengers?</label>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <select className="form-control" id="any-witnesses" aria-describedby="relationTypeError" name="Any witnesses or passengers" value={areWitness} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    setAreWitness(e.target.value);
                    localStorage.setItem("autoclaim-arewitness",e.target.value);
                }}>
                    <option value="">Select...</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>
            </div>
		</div>
        <Collapse in={areWitness === "Yes"}>
            <div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <button className="btn btn-primary" type="button" onClick={() =>{localStorage.setItem("autoclaim-wit1Open",(!openWitnessOne).toString());setOpenWitnessOne(!openWitnessOne)}}><i className="fa fa-pencil" aria-hidden="true" />&nbsp;First Witness or Passenger</button>
                </div>
                <Collapse className="outline col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom" in={openWitnessOne}>
                    <div>
                        <div className="form-group">
                            <label className="control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" htmlFor="witness-one-name">Name and Address:</label>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <textarea className="form-control" id="witness-one-name" aria-describedby="witnessOneName" maxLength={75} placeholder="John Smith 123 Main Street, Town, State " name="First witness or passenger Name and Address" value={witnessOneNameAndAddress} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                    setWitnessOneNameAndAddress(e.target.value);
                                }} />
                                <p id="witnessOneName"><strong>Maximum 75 characters.  You have used {witnessOneNameAndAddress.length} characters.</strong></p>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                                <label className="control-label" htmlFor="witness-one-phone">Phone Number:</label>
                                <PhoneInput id="witness-one-phone" placeholder="(123)-456-7890" name="Witness One Phone" aria-invalid={showError && (witnessOnePhone !== "" && !isValidPhoneNumber(witnessOnePhone))} aria-describedby="witnessOnePhoneError" country="US" international={false} className="form-control" value={witnessOnePhone} maxLength={14} onChange={(phone: string) => {
                                    if (!phone) phone = "";
                                    setWitnessOnePhone(phone);
                                }} />
                                <p id="witnessOnePhoneError" className={showError && (witnessOnePhone !== "" && !isValidPhoneNumber(witnessOnePhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
                            </div>
                            <div className="col-lg-4 col-md-7 col-sm-12 col-xs-12">
                                <label className="control-label" htmlFor="witness-one-location">What vehicle were they in?</label>
                                <select className="form-control" id="witness-one-location" aria-describedby="relationTypeError" name="Any witnesses or passengers" value={witnessOneLocation} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                    setWitnessOneLocation(e.target.value);
                                }}>
                                    <option value="">Select...</option>
                                    <option value="Insured Vehicle">Insured Vehicle</option>
                                    <option value="Other Vehicle">Other Vehicle</option>
                                    <option value="None">None</option>
                                </select>
                            </div>
                            <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                <label className="control-label" htmlFor="witness-one-witness">Passenger or Witness:</label>
                                <select className="form-control" id="witness-one-witness" aria-describedby="relationTypeError" name="Is Witness or Passenger" value={witnessOneOrPassenger} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                    setWitnessOneOrPassenger(e.target.value);
                                }}>
                                    <option value="">Select...</option>
                                    <option value="Passenger">Passenger</option>
                                    <option value="Witness">Witness</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </Collapse>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <button className="btn btn-primary" type="button" onClick={() =>{localStorage.setItem("autoclaim-wit2Open",(!openWitnessTwo).toString());setOpenWitnessTwo(!openWitnessTwo)}}><i className="fa fa-pencil" aria-hidden="true" />&nbsp;Second Witness or Passenger</button>
                </div>
                <Collapse className="outline col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom" in={openWitnessTwo}>
                    <div>
                    <div className="form-group">
                        <label className="control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" htmlFor="witness-two-name">Name and Address:</label>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <textarea className="form-control" id="witness-two-name" maxLength={75} aria-describedby="witnessTwoName" placeholder="John Smith 123 Main Street, Town, State " name="Second witness or passenger Name and Address" value={witnessTwoNameAndAddress} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                setWitnessTwoNameAndAddress(e.target.value);
                            }} />
                            <p id="witnessTwoName"><strong>Maximum 75 characters.  You have used {witnessTwoNameAndAddress.length} characters.</strong></p>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                            <label className="control-label" htmlFor="witness-two-phone">Phone Number:</label>
                            <PhoneInput id="witness-two-phone" placeholder="(123)-456-7890" name="Witness Two Phone" aria-invalid={showError && (witnessTwoPhone !== "" && !isValidPhoneNumber(witnessTwoPhone))} aria-describedby="witnessTwoPhoneError" country="US" international={false} className="form-control" value={witnessTwoPhone} maxLength={14} onChange={(phone: string) => {
                                if (!phone) phone = "";
                                setWitnessTwoPhone(phone);
                            }} />
                            <p id="witnessTwoPhoneError" className={showError && (witnessTwoPhone !== "" && !isValidPhoneNumber(witnessTwoPhone)) ? "error" : "error-hidden"}>Please provide a valid phone number</p>
                        </div>
                        <div className="col-lg-4 col-md-7 col-sm-12 col-xs-12">
                            <label className="control-label" htmlFor="witness-two-location">What vehicle were they in?</label>
                            <select className="form-control" id="witness-two-location" aria-describedby="relationTypeError" name="Any witnesses or passengers" value={witnessTwoLocation} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                setWitnessTwoLocation(e.target.value);
                            }}>
                                <option value="">Select...</option>
                                <option value="Insured Vehicle">Insured Vehicle</option>
                                <option value="Other Vehicle">Other Vehicle</option>
                                <option value="None">None</option>
                            </select>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                            <label className="control-label" htmlFor="witness-two-witness">Passenger or Witness:</label>
                            <select className="form-control" id="witness-two-witness" aria-describedby="relationTypeError" name="Is Witness or Passenger" value={witnessTwoOrPassenger} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                setWitnessTwoOrPassenger(e.target.value);
                            }}>
                                <option value="">Select...</option>
                                <option value="Passenger">Passenger</option>
                                <option value="Witness">Witness</option>
                            </select>
                        </div>
                    </div>
                    </div>
                </Collapse>
                <p><strong>*If there are any additional witnesses or passengers, please explain in the remarks section below</strong></p>
            </div>
        </Collapse>
		<div className="closing-remarks">
			<label className="control-label" htmlFor="remarks">Remarks:</label>
            <div>
                <textarea id="remarks" name="remarks" value={remarks} aria-describedby="closingRemarks" className="form-control" maxLength={700} rows={6} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                    setRemarks(e.target.value);
                }} />
				<p id="closingRemarks"><strong>Maximum 700 characters.  You have used {remarks.length} characters.</strong></p>
			</div>
		</div>
	</div>;

	function updateClaim() {
		claim.areInjuries = areInjuries === "Yes" ? true : false;
		claim.areWitnessPassengers = areWitness === "Yes" ? true : false;
		claim.additionalAnswers["injuryOneName"] = injuryOneNameAndAddress;
		claim.additionalAnswers["injuryOnePhone"] = injuryOnePhone;
		claim.additionalAnswers["injuryOneLocation"] = injuryOneLocation;
		claim.additionalAnswers["injuryOneDescription"] = injuryOneDescription;
		claim.additionalAnswers["injuryTwoName"] = injuryTwoNameAndAddress;
		claim.additionalAnswers["injuryTwoPhone"] = injuryTwoPhone;
		claim.additionalAnswers["injuryTwoLocation"] = injuryTwoLocation;
		claim.additionalAnswers["injuryTwoDescription"] = injuryTwoDescription;
		claim.additionalAnswers["witnessOneName"] = witnessOneNameAndAddress;
		claim.additionalAnswers["witnessOnePhone"] = witnessOnePhone;
		claim.additionalAnswers["witnessOneLocation"] = witnessOneLocation;
		claim.additionalAnswers["witnessOnePassenger"] = witnessOneOrPassenger;
		claim.additionalAnswers["witnessTwoName"] = witnessTwoNameAndAddress;
		claim.additionalAnswers["witnessTwoPhone"] = witnessTwoPhone;
		claim.additionalAnswers["witnessTwoLocation"] = witnessTwoLocation;
		claim.additionalAnswers["witnessTwoPassenger"] = witnessTwoOrPassenger;
        claim.remarks = remarks;
		return claim;
	}

	function goToStep(step: number) {
		goBack(step, updateClaim());
	}

    function submitClaim()
    {
        let claim = updateClaim();
        submit(claim);
        
    }
}
